import helpers from '../../../util/helpers'
import axios from 'axios'
import {store} from '../../store'

const getDefaultState = () => {
  return {
    callServerType: null,
    callApiUrl: '',
    callWebsocketUrl: '',
    callStatusUrl: '',
    callMode: 'NEOMECCA',
    callPort: '3025'
  }
}
const state = getDefaultState()

const getters = {
  callApiUrl: (state) => {
    return state.callApiUrl
  },
  callWebsocketUrl: (state) => {
    return state.callWebsocketUrl
  },
  callStatusUrl: (state) => {
    return state.callStatusUrl
  },
  callMode: (state) => {
    return state.callMode
  }
}

const actions = {
}

const mutations = {
  setCallServer (state, parsedInfo) {
    if (parsedInfo.callServerType && parsedInfo.callServerType.indexOf('KT') > -1) {
      state.callMode = 'KT'
    }

    // 사용중에 콜 모듈 승인이 받고, 토큰이 갱신이 안된 상황을 위해 콜모듈 데이터 체크 로직 추가
    state.callApiUrl = ''
    state.callWebsocketUrl = ''
    if (parsedInfo.callServerType) {
      state.callApiUrl = helpers.findCallApiUrl(parsedInfo.callServerType)
      state.callWebsocketUrl = state.callMode === 'KT' ? `${helpers.findCallWebsocketUrl(parsedInfo.callServerType)}:8060` : helpers.findCallWebsocketUrl(parsedInfo.callServerType) + ':' + state.callPort
      state.callServerType = parsedInfo.callServerType
    } else {
      if (parsedInfo.agentMappingBrandViews && parsedInfo.agentMappingBrandViews.length > 0) {
        parsedInfo.agentMappingBrandViews.forEach(d => {
          axios({
            method: 'get',
            url: `/api/module/fetchCallModuleData`,
            params: {
              brandId: d.brandId
            },
            headers: {'X-Requested-With': 'XMLHttpRequest'}
          }).then((result) => {
            if (result.data.code === 0 && result.data.data) {
              store.dispatch('refresh')
            }
          })
        })
      }
    }
  },
  setCallStatus (state, parsedInfo) {
    state.callStatusUrl = helpers.findCallStatusUrl()
  },
  changeCallWebSocketUrl (state) {
    state.callPort = state.callPort === '3025' ? '3026' : '3025'
    const callWebsocketUrl = helpers.findCallWebsocketUrl(state.callServerType)
    state.callWebsocketUrl = callWebsocketUrl ? callWebsocketUrl + ':' + state.callPort : callWebsocketUrl
  },
  setCallMode (state, payload) {
    state.callMode = payload
  },
  SET_CALL_API_URL (state, payload) {
    state.callApiUrl = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/call/callServer.js